import React, { useEffect } from 'react';
import { flow } from 'lodash';
import { Switch, Route, Redirect } from 'react-router-dom';
import Helmet from 'react-helmet';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';

import useAuth from '@giro/shared-hooks/useAuth.hook';
import useNotification from '@giro/shared-hooks/useNotification.hook';
import usePdvAccess from '@giro-pdv/hooks/usePdvAccess.hook';
import useIsMobile from './hooks/useIsMobile.hook';

import PDVModule from '@giro-pdv/modules/pdv/PDV.module';
import ReportsModule from '@giro-pdv/modules/reports/Reports.module';
import LoginModule from '@giro-pdv/modules/login/Login.module';
import ReceiptModule from './modules/receipt/Receipt.module';
import MonitoringModule from './modules/monitoring/Monitoring.module';
import SetupModule from './modules/setup/Setup.module';
import PaymentLinksModule from './modules/paymentLinks/PaymentLinks.module';
import TerminalsModule from './modules/terminals/Terminals.module';
import TerminalAccreditationScreen from './modules/terminalAccreditation/TerminalAccreditation.screen';

import DialogReceiptComponent from './components/DialogReceipt.component';

import ROUTES from './constants/routes.constant';

import menu from './store/menu';

import useJivoChatHook from './hooks/useJivoChat.hook';
import SlipsModule from './modules/slips/Slips.module';

const Routes = () => {
  useJivoChatHook('OokRHhz3Sz');

  const { pathname } = useLocation();
  const isMobile = useIsMobile();
  const { user, signedIn } = useAuth();
  const dispatch = useDispatch();

  const dispatchRedux = {
    close: flow(menu.action.close, dispatch),
  };

  useNotification();

  useEffect(() => {
    if (isMobile) {
      dispatchRedux.close();
    }
  }, [pathname, isMobile]);

  useEffect(() => {
    if (signedIn && process.env.REACT_APP_HOTJAR === 'true') {
      const { user: userState } = user || {};
    }
  }, [signedIn]);

  const {
    isCrea,
    canAccessPdv,
    canAccessPaymentLinks,
    canAccessMonitoring,
    canManageSlips,
    rootRoute,
  } = usePdvAccess();
  const ROOTROUTER = signedIn ? rootRoute : ROUTES.LOGIN.ROOT;

  return (
    <>
      <Switch>
        {(canAccessPdv || canAccessPaymentLinks) && (
          <Route path={ROUTES.PDV.ROOT} component={PDVModule} />
        )}
        <Route path={ROUTES.REPORTS.ROOT} component={ReportsModule} />
        <Route path={ROUTES.LOGIN.ROOT} component={LoginModule} />
        {/* PUBLIC (no auth) — the terminal-accreditation QR opens this on a phone. */}
        <Route
          exact
          path={ROUTES.TERMINAL_ACCREDITATION.ROOT}
          component={TerminalAccreditationScreen}
        />
        <Route path={ROUTES.RECEIPT.ROOT} component={ReceiptModule} />
        {canAccessMonitoring && (
          <Route path={ROUTES.MONITORING.ROOT} component={MonitoringModule} />
        )}
        <Route path={ROUTES.SETUP.ROOT} component={SetupModule} />
        {canManageSlips && (
          <Route path={ROUTES.SLIPS.ROOT} component={SlipsModule} />
        )}
        <Route path={ROUTES.TERMINALS.ROOT} component={TerminalsModule} />
        {canAccessPaymentLinks && (
          <Route
            path={ROUTES.PAYMENT_LINKS.ROOT}
            component={PaymentLinksModule}
          />
        )}

        <Redirect to={ROOTROUTER} />
      </Switch>

      <DialogReceiptComponent />

      {isCrea && (
        <Helmet>
          <script
            id="webchat__widget"
            src="https://cdn.chatapi.net/webchat/widget/widget.js?cId=1d1cb5482d5558a50061f01f586ef2cf6797aa73c3680eb5047b201b0c4b84fe"
          ></script>
        </Helmet>
      )}

      {!isCrea && (
        <Helmet>
          <script
            id="webchat__widget"
            src="https://cdn.chatapi.net/webchat/widget/widget.js?cId=1d1cb5482d5558a50061f01f586ef2cf6797aa73c3680eb5047b201b0c4b84fe"
          ></script>
        </Helmet>
      )}
    </>
  );
};

export default Routes;
